<!-- <div class="bg-white border border-[#ccd5db] rounded-[3px] p-4 flex items-center justify-between shadow-none relative overflow-hidden group hover:border-[#0079b8] transition-all duration-200">
    <div class="flex-1">
        <span class="text-[11px] font-bold text-[#575757] uppercase tracking-wider">Data Ingested</span>
        <div class="text-[28px] font-light text-[#313131] leading-none mt-1">1.24</div>
        <div class="text-[10px] text-gray-500 font-medium flex items-center mt-1.5">
            <mat-icon class="text-xs mr-0.5 leading-none text-[#2f8400]">trending_up</mat-icon>
            <span class="text-[#2f8400] font-semibold mr-1">+12%</span>
            <span>Total TB/day</span>
        </div>
    </div>
    <div class="bg-[#eef7fc] border border-[#b3e5fc] p-2 rounded-[3px] text-[#0079b8] group-hover:bg-[#0079b8] group-hover:text-white group-hover:border-[#0079b8] transition-all duration-200 flex items-center justify-center">
        <mat-icon class="text-xl leading-none">storage</mat-icon>
    </div>
    <div class="absolute bottom-0 left-0 right-0 h-0.5 bg-[#ccd5db] group-hover:bg-[#0079b8] transition-all duration-200"></div>
</div> -->

<div class="home-wrapper p-7">
    <div class="header border-light-bottom">
        <p class="primary-text hide content-s">{{homeLanderService.titles.overview_title}}</p>
        <div class="title_options">
            <h2 class="primary-text lightest-text">{{homeLanderService.titles.overview}}</h2>
            <div class="right-section">
                <ng-container *ngIf="!(sharedService.$sidebarExpanded | async)">
                    <mat-icon class=" enable-action tooltip-enable" [tooltip]="(sharedService.$sidebarExpanded | async) ? homeLanderService.tooltip.collapse_nav : homeLanderService.tooltip.expand_nav" (click)="sidebarClick()">menu</mat-icon>
                </ng-container>
                <ng-container *ngIf="(sharedService.$sidebarExpanded | async)">
                    <mat-icon class="enable-action tooltip-enable" [tooltip]="(sharedService.$sidebarExpanded | async) ? homeLanderService.tooltip.collapse_nav : homeLanderService.tooltip.expand_nav" (click)="sidebarClick()">menu_open</mat-icon>
                </ng-container>
                <mat-icon class=" enable-action tooltip-enable" [tooltip]="homeLanderService.tooltip.refresh" (click)="refreshClick()">refresh</mat-icon>
                <!-- <img class="icon-l enable-action tooltip-enable" [tooltip]="(sharedService.$sidebarExpanded | async) ? homeLanderService.tooltip.collapse_nav : homeLanderService.tooltip.expand_nav" src="assets/sidebar.svg" (click)="sidebarClick()">
                <img class="icon-m enable-action tooltip-enable" [tooltip]="homeLanderService.tooltip.refresh" src="../../assets/rule/refresh.svg"> -->
            </div>
        </div>

        <p class="primary-text lighter-text content-m">{{homeLanderService.titles.overview_desc}}</p>
    </div>
    <div class="section">
        <div class="section-wrapper border-light white-bg radius-s selected-list px-7">
            <div class="left-section">
                <p class="primary-text bold-text content-xl">{{homeLanderService.titles.welcome}}{{homeLanderService.userName}}</p>
                <p class="primary-text content-m lightest-text">{{homeLanderService.titles.last_refreshed}}{{homeLanderService.todayDate}}</p>
            </div>
            <!-- <div class="right-section">
                <img class="icon-l enable-action tooltip-enable" [tooltip]="(sharedService.$sidebarExpanded | async) ? homeLanderService.tooltip.collapse_nav : homeLanderService.tooltip.expand_nav" src="assets/sidebar.svg" (click)="sidebarClick()">
                <img class="icon-m enable-action tooltip-enable" [tooltip]="homeLanderService.tooltip.refresh" src="../../assets/rule/refresh.svg">
            </div> -->
        </div>
    </div>
    <div class="stats ">
        <p class="primary-text content-s boldest-text">{{homeLanderService.titles.key_indicators}}{{homeLanderService.statTime}}</p>
        <div class="stats-wrapper">
            <ng-container *ngFor="let list of stats">

                <div class="stat-container white-bg p-3 radius-s" [ngClass]="list.value">
                    <ng-container *ngIf="!mat_stats_spinner">
                        <div class="stats-contain-wrapper">
                            <p class="content-s primary-text">{{list.disp}}</p>
                            <h2 class="primary-text lightest-text">{{list.stat}}</h2>
                            <div class="stat-diff pt-1">
                                <mat-icon [ngStyle]="{'color':list.icon_color}">{{list.icon_type}}</mat-icon>
                                <p class="content-s" [ngStyle]="{'color':list.icon_color}">{{list.diff}}</p>
                                <p class="content-s primary-text">{{list.desc}}</p>
                            </div>
                        </div>
                        <div class="stat-right border-light radius-s">
                            <mat-icon>{{list.icon}}</mat-icon>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="mat_stats_spinner">
                        <div class="spinner-wrapper">
                            <mat-spinner class="loading light-text primary-text" diameter="15"></mat-spinner>
                        </div>
                    </ng-container>
                </div>

            </ng-container>
        </div>




        <!-- <div #statsWrapper class="stats-wrapper"></div> -->

    </div>
    <div class="apps">
        <div class="apps-wrapper">
            <ng-container *ngFor="let item of menu">
                <div class="item-wrapper">
                    <p class="primary-text content-s boldest-text">{{item.disp}}</p>
                    <div class="list-wrapper border-light white-bg p-3 radius-s">
                        <ng-container *ngFor="let itemlist of item.list">
                            <div class="itemlist-wrapper enable-action" [ngClass]="itemlist.isSelectable ? '' : 'not-allowed' " (click)="optionClick(itemlist,$event)">
                                <div class="icons border-light radius-s tooltip-enable" [ngStyle]="{'background-color':itemlist.bg,'color':itemlist.color}" [tooltip]="itemlist.disp">
                                    <!-- <img class="icon-l" [src]="itemlist.icon"> -->
                                    <mat-icon>{{itemlist.icon}}</mat-icon>
                                </div>
                                <div class="contents" [ngClass]="itemlist.isSelectable ? '' : 'no-hover'">
                                    <p class="content-m list-text bold-text">{{itemlist.disp}}</p>
                                    <p class="content-s ">{{itemlist.desc}}</p>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
        </div>
        <div class="shortcut">
            <div class="shortcut-wrapper">
                <div class="item-wrapper">
                    <div class="list-wrapper">
                        <div class="tab-selector">
                            <p class="primary-text content-s boldest-text">{{homeLanderService.titles.shortcuts}}</p>

                            <div class="tab-wrapper border-light p-1 radius-s">
                                <ng-container *ngFor="let tab_item of homeLanderService.tabList">
                                    <div class="tab-item content-s p-1 radius-s bolder-text enable-action" (click)="tabClick(tab_item)" [ngClass]="[tab_item.enable ? '' : 'permission-denied' , homeLanderService.selectedTab?.value == tab_item.value ? 'selected-tab' : 'default-tab' ]">
                                        {{tab_item.disp}}
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                        <div class="itemlist-wrapper border-light white-bg  radius-s">
                            <ng-container *ngIf="homeLanderService.selectedTab?.value == 'recent_dashboards'">
                                <div class="dashboard-wrapper">
                                    <table *ngIf="!mat_dashboard_spinner && dashboardList?.length">
                                        <thead>
                                            <tr>
                                                <ng-container *ngFor="let head of homeLanderService.dashboardHeaders">
                                                    <th>{{head}}</th>
                                                </ng-container>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="enable-action" *ngFor=" let dashboard of dashboardList" (click)="dashboardOptionClick('preview',dashboard)">
                                                <td>{{dashboard.dashboard_name}}</td>
                                                <td>{{dashboard.status}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <ng-container *ngIf="!mat_dashboard_spinner && !dashboardList?.length">
                                        <div class="no-result">
                                            <img src="/assets/rule/empty-data.svg">
                                            <p class="lighter-text primary-text content-l">
                                                No Result
                                            </p>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="mat_dashboard_spinner">
                                        <div class="spinner-wrapper">
                                            <mat-spinner class="loading light-text primary-text" diameter="15"></mat-spinner>
                                        </div>
                                    </ng-container>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="homeLanderService.selectedTab?.value == 'recent_searches'">
                                <div class="search-wrapper">
                                    <table *ngIf="!mat_search_spinner && historyList">
                                        <thead>
                                            <tr>
                                                <ng-container *ngFor="let head of homeLanderService.searchHeaders">
                                                    <th>{{head}}</th>
                                                </ng-container>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="enable-action" *ngFor=" let history of historyList?.history_table_rows" (click)="historyClick(history)">
                                                <td class="tooltip-enable" position="left" [tooltip]="history.search">{{history.search}}</td>
                                                <td class="tooltip-enable" [tooltip]="history.created_dt | changetimezone : 'DD MMM YYYY HH:mm'">{{history.created_dt | changetimezone : 'DD MMM YYYY HH:mm'}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <ng-container *ngIf="!mat_search_spinner && !historyList">
                                        <div class="no-result">
                                            <img src="/assets/rule/empty-data.svg">
                                            <p class="lighter-text primary-text content-l">
                                                No Result
                                            </p>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="mat_search_spinner">
                                        <div class="spinner-wrapper">
                                            <mat-spinner class="loading light-text primary-text" diameter="15"></mat-spinner>
                                        </div>
                                    </ng-container>


                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>